import { createAsyncActionTypes } from '../../util/createLifeomicActionTypes';

export default createAsyncActionTypes([
  'QUERY_ANALYTICS',
  'QUERY_ASYNC_ANALYTICS',
  'PCA_QUERY_ANALYTICS',
  'PCA_QUERY_ANALYTICS_START',
  'PCA_QUERY_ANALYTICS_SUCCESS',
  'PCA_QUERY_ANALYTICS_ERROR',
  'EXPRESSION_QUERY_ANALYTICS',
  'EXPRESSION_QUERY_ANALYTICS_START',
  'EXPRESSION_QUERY_ANALYTICS_SUCCESS',
  'EXPRESSION_QUERY_ANALYTICS_ERROR',
  'GENE_STATS_QUERY_ANALYTICS',
  'GENE_STATS_QUERY_ANALYTICS_START',
  'GENE_STATS_QUERY_ANALYTICS_SUCCESS',
  'GENE_STATS_QUERY_ANALYTICS_ERROR',
  'DEMOGRAPHIC_QUERY_ANALYTICS',
  'DEMOGRAPHIC_QUERY_ANALYTICS_START',
  'DEMOGRAPHIC_QUERY_ANALYTICS_ERRORR',
  'DEMOGRAPHIC_QUERY_ANALYTICS_SUCCESS',
  'INSIGHTS_CONFIGURATION',
]);
